import { Core } from "@faire/design-tokens";
export var ARROW_UP = 38;
export var ARROW_DOWN = 40;
export var RETURN_KEY = 13;
export var TAB_KEY = 9;
export var KEY_EVENT_VALUE = "keydown";
export var MAX_SECTION_RESULT_SIZE = 8;
export var MAX_SPLIT_SECTION_RESULT_SIZE = 5;
export var MAX_SUGGESTION_ITEMS_PER_SECTION = 5;
export var MAX_SUGGESTION_TOP_RESULTS = 6;
export var MAX_DESKTOP_SUGGESTION_ITEM_PER_SECTION = 3;
export var MAX_SEARCH_RECOMMENDATION_PER_SECTION = 7;
export var MAX_SUGGESTION_BRAND_SUGGESTIONS = 5;
export var MAX_DESKTOP_SUGGESTION_BRANDS = 3;
export var MAX_DESKTOP_SUGGESTION_QUERY = 8;
export var MAX_DESKTOP_SUGGESTION_BRANDS_OVERFLOW = 2;
export var MAX_DESKTOP_SUGGESTION_QUERY_OVERFLOW = 2;
export var RESULT_DROPDOWN_SVG_ICON_PROPS = {
    height: "16px",
    width: "16px",
    color: Core.text.default,
    strokeWidth: 1
};
export var RESULT_DROPDOWN_ITEM_DATA_TEST_ID = "result-dropdown-item-text";
// Sections for default state (user hasn't typed anything)
export var getRecentSearchesHeader = function(strictLocalize) {
    return strictLocalize({
        id: "jk3zjm",
        defaultMessage: [
            {
                type: 0,
                value: "Recent searches"
            }
        ]
    });
};
export var getRecentlyViewedHeader = function(strictLocalize) {
    return strictLocalize({
        id: "DuXg60",
        defaultMessage: [
            {
                type: 0,
                value: "Recently viewed"
            }
        ]
    });
};
export var getTrendingSearchesHeader = function(strictLocalize) {
    return strictLocalize({
        id: "qCPrIW",
        defaultMessage: [
            {
                type: 0,
                value: "Trending searches"
            }
        ]
    });
};
export var getTrendingBrandsHeader = function(strictLocalize) {
    return strictLocalize({
        id: "hUZzPs",
        defaultMessage: [
            {
                type: 0,
                value: "Trending brands"
            }
        ]
    });
};
// Sections for activated state (user has started typing)
export var getSuggestedTermsHeader = function(strictLocalize) {
    return strictLocalize({
        id: "ql8+uO",
        defaultMessage: [
            {
                type: 0,
                value: "Suggested terms"
            }
        ]
    });
};
export var getBrandsYouMightKnowHeader = function(strictLocalize) {
    return strictLocalize({
        id: "szCwBY",
        defaultMessage: [
            {
                type: 0,
                value: "Brands you might know"
            }
        ]
    });
};
export var getBrandsHeader = function(strictLocalize) {
    return strictLocalize({
        id: "jWfWEA",
        defaultMessage: [
            {
                type: 0,
                value: "Brands"
            }
        ]
    });
};
export var getTopResultsHeader = function(strictLocalize) {
    return strictLocalize({
        id: "du4nWN",
        defaultMessage: [
            {
                type: 0,
                value: "Top results"
            }
        ]
    });
};
export var getSectionIdMap = function(strictLocalize) {
    var sectionIdMap = {};
    sectionIdMap[getSuggestedTermsHeader(strictLocalize)] = "suggested_terms";
    sectionIdMap[getRecentSearchesHeader(strictLocalize)] = "recent_searches";
    sectionIdMap[getTrendingSearchesHeader(strictLocalize)] = "trending_searches";
    sectionIdMap[getTrendingBrandsHeader(strictLocalize)] = "trending_brands";
    sectionIdMap[getBrandsHeader(strictLocalize)] = "brands";
    sectionIdMap[getRecentlyViewedHeader(strictLocalize)] = "recently_viewed";
    sectionIdMap[getTopResultsHeader(strictLocalize)] = "top_results";
    sectionIdMap[getBrandsYouMightKnowHeader(strictLocalize)] = "brands_you_may_know";
    return sectionIdMap;
};
